/**
 * Демо-карточка отрисовалась — значит ручка промолчала.
 *
 * ЗАЧЕМ. По репозиторию живёт приём: при пустом ответе секция подставляет
 * демонстрационные карточки (`allowDemoFallback`, `isDemo: true`) и рисуется как
 * нормальная. Из-за этого «ручка упала» и «у нас просто нет рекомендаций»
 * неразличимы — ни для пользователя, ни для нас. Падение recently-viewed так и
 * жило: четыре одинаковых заглушки на месте живых товаров.
 *
 * Пока заглушки не вырезаны везде, они хотя бы перестают быть невидимыми.
 *
 * ПРИЁМНИКА В ПРОДЕ ПОКА НЕТ. В проекте нет ни библиотеки аналитики, ни ручки
 * для событий — поэтому здесь СЕМА, а не молчаливый no-op: события копятся в
 * счётчике, который видно из консоли, а транспорт подключается одной строкой,
 * когда приёмник появится. Тихо терять их было бы тем же самым сокрытием, от
 * которого этот модуль и заведён.
 */

export type DemoCardReason = 'empty' | 'error'

export interface DemoCardEvent {
  /** Какая секция нарисовала заглушку: 'search.you-may-like', 'home.brands'… */
  section: string
  /** Какая ручка промолчала — чтобы не искать её по коду. */
  endpoint: string
  reason: DemoCardReason
  /** Сколько заглушек нарисовано в этой секции. */
  count: number
}

export type DemoCardSink = (event: DemoCardEvent) => void

const registry: { sink: DemoCardSink | null } = { sink: null }

/** Счётчик на случай, когда приёмник ещё не подключён. Читается из консоли. */
const seen: DemoCardEvent[] = []

declare global {
  interface Window {
    __fairDemoCards?: DemoCardEvent[]
  }
}

export function setDemoCardSink(sink: DemoCardSink | null): void {
  registry.sink = sink
}

export function isDevBuild(): boolean {
  return Boolean(import.meta.env?.DEV)
}

/**
 * Сообщить, что секция нарисовала заглушки.
 *
 * НИКОГДА НЕ БРОСАЕТ: это наблюдение за страницей, которая уже отрисовалась.
 * Сбой отчёта не должен превращать работающую страницу в сломанную.
 */
export function reportDemoCards(event: DemoCardEvent): void {
  if (event.count <= 0) return
  try {
    seen.push(event)
    if (typeof window !== 'undefined') {
      window.__fairDemoCards = seen
    }
    if (registry.sink) {
      registry.sink(event)
      return
    }
    if (isDevBuild()) {
      // eslint-disable-next-line no-console -- ровно то, что должно бросаться в глаза
      console.warn(
        `[demo-card] секция «${event.section}» нарисовала ${event.count} заглушек: `
        + `ручка ${event.endpoint} ответила ${event.reason}`,
      )
    }
  } catch {
    // граница: неотправленное событие не ломает страницу
  }
}

/** Что уже накопилось — для консоли и для тестов. */
export function drainDemoCardEvents(): DemoCardEvent[] {
  return [...seen]
}

export function resetDemoCardEvents(): void {
  seen.length = 0
  if (typeof window !== 'undefined') window.__fairDemoCards = seen
}
